export const styles = {
  eventEnd: {
    marginTop: "50px",
    fontWeight: 500,
    padding: "5px 0",
    borderRadius: "5px",
    backgroundColor: "events.grayShade1",
    color: "text.primary",

    "& span": {
      marginLeft: "25px",
      marginRight: "80px",
    },
  },
};
